import React, {useMemo} from 'react'
import {Outlet} from 'react-router-dom';
import useEmailRoutes from 'routes/dev/email/email.routes';
import useHydrateRoutes from 'routes/dev/hydrate/hydrate.routes';
import utils from 'helpers/utils';

export default function useDevRoutes () {
  const emailRoutes = useEmailRoutes();
  const hydrateRoutes = useHydrateRoutes();
  return useMemo(() => {
    const route = [
      {
        path: 'email',
        element: <emailRoutes.WrapperComponent><Outlet /></emailRoutes.WrapperComponent>,
        children: emailRoutes.route,
        handle: {
          auth: utils.createAuth({attribute: 'dev.email.route'})
        }
      },
      {
        path: 'hydrate',
        element: <hydrateRoutes.WrapperComponent><Outlet /></hydrateRoutes.WrapperComponent>,
        children: hydrateRoutes.route,
        handle: {
          auth: utils.createAuth({attribute: 'dev.hydrate.route'})
        }
      }
    ];

    return {
      WrapperComponent: React.Fragment,
      route: route
    };
  }, [emailRoutes, hydrateRoutes]);
};
